import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function InsuranceReinsuranceLicenseMauritius() {

    return (
        <main className='main'>

            <IntroSection
                title="Insurance & Reinsurance License – Mauritius"
                subtitle="Establish Insurance, Reinsurance & Captive Companies in a Tier-1 IFC"
                description="
                <b>Mauritius</b> provides a <b>well-respected, regulator-approved framework</b> for <b>insurance and reinsurance firms</b>, supervised by the <b>Financial Services Commission (FSC)</b>.
                <br/>
                Licenses are available for <b>general insurance</b>, <b>life insurance</b>, <b>captives</b>, and <b>reinsurers</b>, making <b>Mauritius</b> one of the <b>most credible insurance hubs</b> in <b>Africa</b> and the <b>Indian Ocean</b>.
                "
                badges={
                    [
                        "Captives",
                        "General Insurance",
                        "Life Insurance",
                        "Reinsurance"
                    ]
                }
                buttonText="Request a Mauritius Insurance Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/gibraltar-crypto-dlt-license-hero.png")}
                imageAlt=""
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Mauritius for Insurance?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "Tier-1 Reputation",
                                                text: "FSC is internationally recognized."
                                            },
                                            {
                                                title: "Flexible Classes",
                                                text: "General, life, captive, and reinsurance options available."
                                            },
                                            {
                                                title: "Strategic Location",
                                                text: "Serves Africa, Asia, and India."
                                            },
                                            {
                                                title: "Lower Entry Barriers",
                                                text: "More affordable than Bermuda or EU jurisdictions."
                                            },
                                            {
                                                title: "Tax Treaties",
                                                text: "Access to 40+ Double Taxation Treaties."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Types of Insurance Licenses in Mauritius"
                        blocks={[
                            {
                                title: "Captive Insurance License",
                                items: [
                                    { text: "Corporations insure their own risks." },
                                    { text: "Popular for shipping, energy, and multinationals." },
                                    { text: "Lower solvency requirements." }
                                ]
                            },
                            {
                                title: "General Insurance License",
                                items: [
                                    { text: "Covers property, liability, casualty, and specialty lines." },
                                    { text: "Serves both local and international clients." }
                                ]
                            },
                            {
                                title: "Life Insurance License",
                                items: [
                                    { text: "Covers life, health, annuities, and retirement products." },
                                    { text: "Requires stronger actuarial frameworks." }
                                ]
                            },
                            {
                                title: "Reinsurance License",
                                items: [
                                    { text: "Companies offering reinsurance services globally." },
                                    { text: "Mauritius is a rising hub for African & Asian reinsurance." }
                                ]
                            },
                            {
                                title: "Intermediary Licenses",
                                items: [
                                    { text: "For insurance brokers, agents, and advisors." }
                                ]
                            }
                        ]}
                    />


                    <LocationTimeline
                        title="Capital & Requirements"
                        item={
                            [
                                {
                                    title: "Captive Insurance",
                                    text: "USD 125,000 minimum capital requirement."
                                },
                                {
                                    title: "General Insurance",
                                    text: "USD 250,000 minimum capital requirement."
                                },
                                {
                                    title: "Life Insurance",
                                    text: "USD 350,000 minimum capital requirement."
                                },
                                {
                                    title: "Reinsurance Companies",
                                    text: "USD 500,000+ minimum capital requirement."
                                },
                                {
                                    title: "Entity Requirement",
                                    text: "Global Business Company (GBC) registration required."
                                },
                                {
                                    title: "Resident Presence",
                                    text: "Local office, compliance officer, and directors required."
                                },
                                {
                                    title: "AML/KYC Compliance",
                                    text: "Mandatory under FSC standards."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of a Mauritius Insurance License'
                        services={
                            [
                                {
                                    title: "International Recognition",
                                    text: "Stronger than Seychelles or St Lucia."
                                },
                                {
                                    title: "Multiple Classes",
                                    text: "General, life, reinsurance, and captive insurance options."
                                },
                                {
                                    title: "Tax Efficiency",
                                    text: "Double Taxation Treaty benefits for international operations."
                                },
                                {
                                    title: "Strategic Hub",
                                    text: "Provides access to Africa, India, and Asia markets."
                                },
                                {
                                    title: "Cost Advantage",
                                    text: "Lower costs than Bermuda while maintaining Tier-1 credibility."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Pre-Application Consultation",
                                    text: "Define the insurance class for licensing."
                                },
                                {
                                    title: "Entity Incorporation",
                                    text: "Register a Mauritius Global Business Company (GBC)."
                                },
                                {
                                    title: "Application Preparation",
                                    text: "Prepare actuarial studies, business plan, and AML/KYC documentation."
                                },
                                {
                                    title: "FSC Review",
                                    text: "Regulator conducts due diligence and solvency checks."
                                },
                                {
                                    title: "Approval & License Issuance",
                                    text: "Typically completed in 6–9 months."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "6–9 months.",
                                },
                                {
                                    name: "Setup Costs",
                                    description: "from USD 70,000+ (legal, actuarial, compliance)."
                                },
                                {
                                    name: "Capital Requirement",
                                    description: "USD 125k–500k depending on license."
                                },
                                {
                                    name: "Annual Costs",
                                    description: "FSC fees, audits, actuarial compliance."
                                },

                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Specialists in insurance & reinsurance licensing."
                                },
                                {
                                    text: "End-to-end support: incorporation, FSC filing, actuarial documentation."
                                },
                                {
                                    text: "Network of actuaries, reinsurers, and compliance officers."
                                },
                                {
                                    text: "Comparative analysis: Mauritius vs Malta vs Seychelles vs Bermuda."
                                },
                                {
                                    text: "Ongoing support for solvency and compliance."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to establish an insurance, reinsurance, or captive company?"
                        description="Mauritius offers Tier-1 insurance licenses under FSC, trusted in Africa, India, and beyond."
                        buttonText="Book a Mauritius Insurance License Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};
const faqData = [
    {
        question: "What’s the capital requirement for a captive insurer in Mauritius?",
        content: [
            { type: "answer", text: "USD 125,000." },
        ],
    },
    {
        question: "Does Mauritius issue reinsurance licenses?",
        content: [
            { type: "answer", text: "Yes — with minimum capital of USD 500k." },
        ],
    },
    {
        question: "Can international insurers redomicile to Mauritius?",
        content: [
            { type: "answer", text: "Yes — Mauritius allows company redomiciliation." },
        ],
    },
    {
        question: "Why Mauritius over Bermuda or Cayman?",
        content: [
            { type: "answer", text: "Mauritius is cheaper and treaty-connected, but still Tier-1 credible." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Around 6–9 months." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We set up a reinsurance company in Mauritius. Offshore Advisory guided us through FSC licensing and actuarial setup.",
        author: "Rajiv M.",
        role: "Reinsurance Director"
    },
    {
        quote: "Mauritius was perfect for our captive insurance structure. Offshore Advisory managed compliance and FSC filings seamlessly.",
        author: "Emily K.",
        role: "Risk Manager"
    }
];

